export const styles = theme => ({
  '@global': {
    '.aroya.aroyaJournal #content': {
      overflowY: 'hidden',
    },
  },
  root: {
    display: 'grid',
    gridTemplateAreas: [
      '"tabs tabs"',
      '"filters table"'
    ].join('\n'),
    gridTemplateColumns: 'minmax(auto, 260px) 1fr',
    gridTemplateRows: 'minmax(2rem, auto) 1fr',
    gap: 'clamp(1rem, 2.66vh, 2rem) clamp(1rem, 1.6vh, 2rem)',
    height: '100%',
    width: '100%',
    '& $title, & $actions': {
      alignSelf: 'center',
    },
    '&.aroya__journal__actions': {
      gridTemplateAreas: [
        '"tabs tabs"',
        '"action actions"',
        '"filters table"'
      ].join('\n'),
      gridTemplateColumns: 'minmax(auto, 260px) 1fr',
      gridTemplateRows: 'minmax(2rem, auto) auto 1fr',
    },
  },
  tabs: {
    gridArea: 'tabs'
  },
  action: {
    gridArea: 'action',
    paddingRight: 15,
  },
  actions: {
    gridArea: 'actions',
  },
  filters: {
    gridArea: 'filters',
    position: 'sticky',
    top: '0px',
    height: '100%',
    overflow: 'hidden',
    '& > [class^=MuiTypography-root]': {
      paddingLeft: theme.spacing(0.5)
    },
    '& > [class*=MuiTypography-caption]': {
      display: 'inline-block',
      margin: theme.spacing(1, 0),
    }
  },
  filtersScrollableArea: {
    overflow: 'hidden auto',
    height: '100%',
    paddingRight: 15,
  },
  searchField: {
    margin: theme.spacing(0, 0, 1.5),
  },
  navIndicator: {
    backgroundColor: theme.palette.primary.light,
  },
  navTab: {
    color: theme.palette.primary.main,
    marginRight: '1rem',
    padding: '0.5rem 1rem',
    borderBottom: '2px solid',
    borderRadius: '0.5rem 0.5rem 0 0',
    borderBottomColor: theme.palette.primary.main,
  },
  switchBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 10px 10px 0px',
    '& > .MuiTypography-root': {
      color: theme.palette.text.primary,
    },
  },
  location: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px',
  },
  checkBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px 10px 5px 0px',
  },
  table: {
    gridArea: 'table',
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  tableRow: {
    cursor: 'pointer',
    backgroundColor: theme.palette.appPrimary.enabled,
    display: 'grid',
    gap: '1.5rem',
    alignItems: 'center',
    padding: '0 1rem',
    borderRadius: theme.shape.borderRadius,
    '&$noDialog': {
      cursor: 'auto',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.primary.active} !important`,
    },
  },
  eventsDate: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    padding: '0 1rem',
  },
  noDialog: {},
  tableCell: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& > div:last-child:not(:first-child)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 36,
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
    marginLeft: 4,
  },
  checkbox: {
    padding: 0,
  },
  overflow: {
    textOverflow: 'ellipsis',
  },
  locationText: {
    alignItems: 'center',
  },
  primaryText: {
    lineHeight: 1,
  },
  secondaryText: {
    color: theme.palette.text.inactive,
  },
  textCenter: {
    textAlign: 'center',
  },
  annotationTypesFilters: {
    margin: theme.spacing(0, 0, 2),
    '& > p': {
      marginBottom: theme.spacing(2)
    },
    '& .MuiButtonBase-root.MuiChip-root': {
      textTransform: 'none',
    },
    '& .MuiButtonBase-root.MuiChip-root.MuiChip-outlined:hover': {
      backgroundColor: theme.palette.primary.enabled,
    },
    '& .MuiButtonBase-root.MuiChip-root.MuiChip-outlined:active': {
      backgroundColor: theme.palette.primary.hovered
    }
  },
  relatedUser: {
    margin: theme.spacing(0, 0, 2),
  },
  clearBtn: {
    width: '10px',
    height: '10px',
    marginLeft: '10px',
  },
  emptyJournalState: {
    textAlign: 'center',
    maxWidth: 550,
    margin: '5px auto',
  },
  userName: {
    color: theme.palette.primary.main,
  },
  annotationTypeFilter: {
    fontWeight: 'bold',
    margin: theme.spacing(0, 1, 1, 0),
    backgroundColor: theme.palette.primary.hovered,
  },
  journalLoading: {
    position: 'absolute',
    bottom: -20,
    left: 'calc(50% - 16px)',
    zIndex: 100,
  },
  resetButtonHidden: {
    visibility: 'hidden',
  }
  // harvestCard: {
  //   display: 'block',
  //   padding: theme.spacing(),
  //   marginBottom: theme.spacing(2),
  //   textDecoration: 'none',
  //   '& $gridItem:not(:last-child)': {
  //     paddingRight: 8,
  //   },
  // },
  // harvestRoom: {
  //   lineHeight: 2.15,
  // },
  // harvestActions: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // chip: {
  //   minWidth: '100%',
  // },
  // gridItem: {},
  // grid250: {
  //   flexBasis: 250,
  // },
  // activeHarvest: {},
  // filterSelect: {
  //   color: theme.palette.batch.main,
  //   padding: theme.spacing(0, 2.5, 0, 0),
  // },
  // centerIcon: {
  //   color: theme.palette.batch.main,
  //   fontSize: 72,
  // },
  // explanatoryText: {
  //   color: theme.palette.gray,
  //   padding: '10px calc(50% - 330px)',
  //   margin: '0 auto',
  //   flex: '0 0 100%',
  // },
})
